import React, { Component } from 'react';

/* Logo Grid Item Component that contains the grid element with nested image */
class ImageGridItem extends Component {

    render() {
        return (
            <div className={this.props.itemClass + ' ' + (this.props.itemGridTweak !== '' ? this.props.itemGridTweak : this.props.itemGridClass) + ' ' + this.props.itemTargetingClass}>
                <div className="inner-flex">
                    <img className={this.props.itemImgClass + ' ' + this.props.itemTargetingClass}
                        src={this.props.itemImgSrc} alt={this.props.itemImageAlt} />
                </div>
            </div>
        );
    }
}

/* Logo Grid Parent Component that builds the logo grid */
class ImageGrid extends Component {

    constructor(props) {
        super(props);
        this.state = {
            imageGridData: {},
            topLevelClass: 'image-grid-block__row'
        };
    }

    componentDidMount() {
        this.setState({ imageGridData: this.props.data });
    }

    render() {

        return (
            <React.Fragment>
                <div className={this.state.topLevelClass + ' row'} tabIndex="0">
                    {(typeof (this.state.imageGridData.itemAttributes) != 'undefined') ? this.state.imageGridData.itemAttributes.map((logoItemDataRow, index) =>

                        <div className={(logoItemDataRow.length < 4) ? 'row row--partial' : 'row'} key={index} 
                        style={{ justifyContent: (logoItemDataRow.length < 4) ? 'center' : '', 
                                WebkitBoxPack: (logoItemDataRow.length < 4) ? 'center' : '' }}>

                            {(typeof (logoItemDataRow) != 'undefined') ? logoItemDataRow.map((logoItemData, index) =>
                                <ImageGridItem
                                    key={index}
                                    itemClass={this.state.imageGridData.itemClass}
                                    itemGridClass={this.state.imageGridData.itemGridClass}
                                    itemImgClass={this.state.imageGridData.itemImgClass}
                                    itemTargetingClass={logoItemData.itemTargetingClass}
                                    itemImgSrc={logoItemData.imageSrc}
                                    itemImageAlt={logoItemData.imageAlt}
                                    itemGridTweak={logoItemData.gridTweak} />
                            ) : ''}
                        </div>

                    ) : ''}
                </div>
            </React.Fragment>
        );
    }
}

export default ImageGrid;